/**
 * Párrafo item
 * @param {*} editor
 */
function italic(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `/k${text}/e`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Cursiva',
    action: italic,
    className: 'zmdi zmdi-format-italic',
    title: 'Cursiva',
  };

  return option;
}
